module.exports = __webpack_public_path__ + "img/9791160574234.34512fef.jpg";